import React from 'react';

export const PlayerContext = React.createContext({});
